import Marketplace from './components/marketplace';
import MarketplaceDetails from './components/details';

export default Marketplace;
export { MarketplaceDetails };